import ReportTabs from './ReportTabs'

export default ReportTabs
